import React, {useState} from 'react';

import {analyticsService} from '../../services/analytics';
import {useTermsStore} from '../../store/slices/termsStore';

const IconPolicyPrivacy = '/icons/lock.png';
import {Logo} from '../../shared/components/Logo';
import {Modal} from '../../shared/components/Modal';
import {LogoutButton} from '../LogoutButton/LogoutButton';
import {PolicyPrivacy} from '../PolicyPrivacy';
import {ButtonWithIconAndWithTooltip} from '../../shared/components/ButtonWithIconAndWithTooltip';
import {TermsTabs} from '../TermsTabs/TermsTabs';
import './Header.style.scss';

const Header = () => {
  const openCloseModalTerms = useTermsStore(
    (state) => state.openCloseModalTerms
  );
  const setOpenCloseModalTerms = useTermsStore(
    (state) => state.setOpenCloseModalTerms
  );
  const [showModal, setShowModal] = useState(false);

  const actionModal = () => {
    const isOpening = !showModal;
    setShowModal(isOpening);
    if (isOpening) {
      analyticsService.trackPrivacyPolicyView();
    }
  };

  const actionModalTerms = () => {
    setOpenCloseModalTerms(!openCloseModalTerms);
  };

  return (
    <>
      <Modal showModal={showModal} showModalFunction={actionModal}>
        <PolicyPrivacy showModalFunction={actionModal} />
      </Modal>
      <Modal
        showModal={openCloseModalTerms}
        showModalFunction={actionModalTerms}
        typeCloseButton="circle"
        disableExternalClick={true}
      >
        <TermsTabs />
      </Modal>

      <div className="header">
        <div className="header__logo">
          <div className="header__logo--size">
            <Logo backgroundTint="dark" />
          </div>
          <h1 className="header__title">Credenciamento Alelo</h1>
        </div>
        <div className="header__links">
          <div className="header__button-container">
            <ButtonWithIconAndWithTooltip
              showButton={true}
              actionButton={actionModal}
              IconButton={IconPolicyPrivacy}
              textTooltip="Nossa Política de Privacidade"
              textImageAlt="Ícone para abertura da politica de privacidade"
            />
          </div>
          <div className="header__button-container">
            <LogoutButton />
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
